import { FilterRemoveOutlineIcon } from './FilterRemoveOutlineIcon';

/**
 * author: Austin Andrews
 * id C6DD0143-A7E3-464D-B0AC-F97E5C51F74C
 * name filter-remove-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/filter-remove-outline.svg
 * tags
 */
export const FunnelRemoveOutlineIcon = FilterRemoveOutlineIcon;
export default FunnelRemoveOutlineIcon